import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import toast from 'react-hot-toast';

const { FiPlus, FiTrash2, FiArrowLeft, FiEdit3, FiX, FiSave, FiClock } = FiIcons;

const TraditionManager = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  
  const initialForm = { title: '', description: '', image_url: '', occurrence: '' };
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = async () => {
    setLoading(true);
    const { data } = await supabase.from('traditions_20240520').select('*').order('created_at');
    setItems(data || []);
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await supabase.from('traditions_20240520').update(formData).eq('id', editingId);
      } else {
        await supabase.from('traditions_20240520').insert([formData]);
      }
      toast.success('Tradition saved');
      setShowForm(false);
      setEditingId(null);
      setFormData(initialForm);
      fetchItems();
    } catch (err) { toast.error(err.message); }
  };

  const handleDelete = async (id) => {
    if (!confirm('Delete this tradition?')) return;
    await supabase.from('traditions_20240520').delete().eq('id', id);
    fetchItems();
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="flex justify-between items-center mb-10">
        <div>
          <button onClick={() => window.history.back()} className="text-sm font-bold text-[#8c7851] flex items-center mb-2 hover:underline">
            <SafeIcon icon={FiArrowLeft} className="mr-1" /> Dashboard
          </button>
          <h1 className="text-4xl font-serif font-bold text-[#2c2c2c]">Family Traditions</h1>
        </div>
        <button 
          onClick={() => { setShowForm(!showForm); setEditingId(null); setFormData(initialForm); }}
          className="px-6 py-3 bg-[#8c7851] text-white rounded-xl font-bold flex items-center gap-2"
        >
          <SafeIcon icon={showForm ? FiX : FiPlus} />
          <span>{showForm ? 'Cancel' : 'New Tradition'}</span>
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="mb-12 bg-white p-8 rounded-[2rem] border-2 border-[#8c7851]/20 shadow-xl space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-1">
              <label className="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Tradition Name</label>
              <input required value={formData.title} onChange={e => setFormData({ ...formData, title: e.target.value })} className="w-full px-4 py-2 rounded-lg border" placeholder="e.g. Sunday Pancake Breakfast" />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-bold text-stone-400 uppercase tracking-widest">When does it happen?</label>
              <input value={formData.occurrence} onChange={e => setFormData({ ...formData, occurrence: e.target.value })} className="w-full px-4 py-2 rounded-lg border" placeholder="e.g. Every Christmas Eve" />
            </div>
          </div>
          <div className="space-y-1">
            <label className="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Image URL (Postimages Direct Link)</label>
            <input value={formData.image_url} onChange={e => setFormData({ ...formData, image_url: e.target.value })} className="w-full px-4 py-2 rounded-lg border" />
          </div>
          <div className="space-y-1">
            <label className="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Description / Story</label>
            <textarea value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} className="w-full px-4 py-2 rounded-lg border h-32" />
          </div>
          <button type="submit" className="w-full bg-[#2c2c2c] text-white py-4 rounded-xl font-bold flex items-center justify-center gap-2">
            <SafeIcon icon={FiSave} />
            <span>Save Tradition</span>
          </button>
        </form>
      )}

      <div className="grid gap-4">
        {items.map(item => (
          <div key={item.id} className="bg-white p-4 rounded-2xl border border-stone-100 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-stone-50 rounded-lg flex items-center justify-center text-[#8c7851]">
                <SafeIcon icon={FiClock} />
              </div>
              <div>
                <h3 className="font-bold">{item.title}</h3>
                <p className="text-xs text-stone-400">{item.occurrence}</p>
              </div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => { setFormData(item); setEditingId(item.id); setShowForm(true); }} className="p-2 text-blue-500"><SafeIcon icon={FiEdit3} /></button>
              <button onClick={() => handleDelete(item.id)} className="p-2 text-red-500"><SafeIcon icon={FiTrash2} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TraditionManager;